import { ReportSdk } from 'lib-klab-sdks';

export const keystrokeReportsSdkMock = {
    getEmployeeKeystrokes: (
        employeeId: number,
        startDate: string,
        endDate: string,
        page = 0,
        size = 10,
        search?: string,
    ): ReportSdk.KeystrokeReportResponse => {
        const baseRows: ReportSdk.KeystrokeItem[] = [
            {
                activityEventId: 101,
                workSessionId: `ws-${employeeId}-1`,
                sourceType: 'APP',
                displayName: 'google',
                keySequence: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                keyCount: 228,
                mouseClicks: 15,
                startedAt: `${startDate}T09:15:00`,
                endedAt: `${startDate}T09:16:00`,
            },
            {
                activityEventId: 102,
                workSessionId: `ws-${employeeId}-2`,
                sourceType: 'WEB',
                displayName: 'yopmail',
                keySequence: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Praesent elementum facilisis leo vel fringilla.',
                keyCount: 260,
                mouseClicks: 8,
                startedAt: `${startDate}T09:30:00`,
                endedAt: `${startDate}T09:31:00`,
            },
            {
                activityEventId: 103,
                workSessionId: `ws-${employeeId}-3`,
                sourceType: 'APP',
                displayName: 'youtube',
                keySequence: 'Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper.',
                keyCount: 215,
                mouseClicks: 32,
                startedAt: `${startDate}T10:00:00`,
                endedAt: `${startDate}T10:01:00`,
            },
            {
                activityEventId: 104,
                workSessionId: `ws-${employeeId}-4`,
                sourceType: 'WEB',
                displayName: 'github',
                keySequence: 'Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci.',
                keyCount: 265,
                mouseClicks: 4,
                startedAt: `${startDate}T11:20:00`,
                endedAt: `${startDate}T11:25:00`,
            },
            {
                activityEventId: 105,
                workSessionId: `ws-${employeeId}-5`,
                sourceType: 'APP',
                displayName: 'slack',
                keySequence: 'Nam dui erat, auctor a, dignissim quis, sollicitudin eu, felis. Pellentesque nisi purus, imperdiet id, aliquet at, egestas ut, orci. Pellentesque scelerisque interdum leo. In in tortor vitae justo interdum porta. Cras libero dolor, porta egestas.',
                keyCount: 235,
                mouseClicks: 18,
                startedAt: `${startDate}T13:10:00`,
                endedAt: `${startDate}T13:15:00`,
            },
            {
                activityEventId: 106,
                workSessionId: `ws-${employeeId}-6`,
                sourceType: 'APP',
                displayName: 'intellij',
                keySequence: 'Phasellus a est. Phasellus magna. In hac habitasse platea dictumst. Curabitur at lacus ac velit ornare lobortis. Curabitur a felis in nunc fringilla tristique. Morbi mattis ullamcorper velit. Suspendisse eu ligula.',
                keyCount: 180,
                mouseClicks: 55,
                startedAt: `${startDate}T15:45:00`,
                endedAt: `${startDate}T15:55:00`,
            },
            {
                activityEventId: 107,
                workSessionId: `ws-${employeeId}-7`,
                sourceType: 'WEB',
                displayName: 'github',
                keySequence: 'Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci.',
                keyCount: 265,
                mouseClicks: 4,
                startedAt: `${startDate}T11:20:00`,
                endedAt: `${startDate}T11:25:00`,
            },
            {
                activityEventId: 108,
                workSessionId: `ws-${employeeId}-8`,
                sourceType: 'APP',
                displayName: 'slack',
                keySequence: 'Nam dui erat, auctor a, dignissim quis, sollicitudin eu, felis. Pellentesque nisi purus, imperdiet id, aliquet at, egestas ut, orci. Pellentesque scelerisque interdum leo. In in tortor vitae justo interdum porta. Cras libero dolor, porta egestas.',
                keyCount: 235,
                mouseClicks: 18,
                startedAt: `${startDate}T13:10:00`,
                endedAt: `${startDate}T13:15:00`,
            },
            {
                activityEventId: 109,
                workSessionId: `ws-${employeeId}-9`,
                sourceType: 'APP',
                displayName: 'intellij',
                keySequence: 'Phasellus a est. Phasellus magna. In hac habitasse platea dictumst. Curabitur at lacus ac velit ornare lobortis. Curabitur a felis in nunc fringilla tristique. Morbi mattis ullamcorper velit. Suspendisse eu ligula.',
                keyCount: 180,
                mouseClicks: 55,
                startedAt: `${startDate}T15:45:00`,
                endedAt: `${startDate}T15:55:00`,
            },
            {
                activityEventId: 110,
                workSessionId: `ws-${employeeId}-10`,
                sourceType: 'WEB',
                displayName: 'github',
                keySequence: 'Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci.',
                keyCount: 265,
                mouseClicks: 4,
                startedAt: `${startDate}T11:20:00`,
                endedAt: `${startDate}T11:25:00`,
            },
            {
                activityEventId: 111,
                workSessionId: `ws-${employeeId}-11`,
                sourceType: 'APP',
                displayName: 'slack',
                keySequence: 'Nam dui erat, auctor a, dignissim quis, sollicitudin eu, felis. Pellentesque nisi purus, imperdiet id, aliquet at, egestas ut, orci. Pellentesque scelerisque interdum leo. In in tortor vitae justo interdum porta. Cras libero dolor, porta egestas.',
                keyCount: 235,
                mouseClicks: 18,
                startedAt: `${startDate}T13:10:00`,
                endedAt: `${startDate}T13:15:00`,
            },
            {
                activityEventId: 112,
                workSessionId: `ws-${employeeId}-12`,
                sourceType: 'APP',
                displayName: 'intellij',
                keySequence: 'Phasellus a est. Phasellus magna. In hac habitasse platea dictumst. Curabitur at lacus ac velit ornare lobortis. Curabitur a felis in nunc fringilla tristique. Morbi mattis ullamcorper velit. Suspendisse eu ligula.',
                keyCount: 180,
                mouseClicks: 55,
                startedAt: `${startDate}T15:45:00`,
                endedAt: `${startDate}T15:55:00`,
            },
            {
                activityEventId: 113,
                workSessionId: `ws-${employeeId}-13`,
                sourceType: 'WEB',
                displayName: 'github',
                keySequence: 'Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci.',
                keyCount: 265,
                mouseClicks: 4,
                startedAt: `${startDate}T11:20:00`,
                endedAt: `${startDate}T11:25:00`,
            },
            {
                activityEventId: 114,
                workSessionId: `ws-${employeeId}-14`,
                sourceType: 'APP',
                displayName: 'slack',
                keySequence: 'Nam dui erat, auctor a, dignissim quis, sollicitudin eu, felis. Pellentesque nisi purus, imperdiet id, aliquet at, egestas ut, orci. Pellentesque scelerisque interdum leo. In in tortor vitae justo interdum porta. Cras libero dolor, porta egestas.',
                keyCount: 235,
                mouseClicks: 18,
                startedAt: `${startDate}T13:10:00`,
                endedAt: `${startDate}T13:15:00`,
            },
            {
                activityEventId: 115,
                workSessionId: `ws-${employeeId}-15`,
                sourceType: 'APP',
                displayName: 'intellij',
                keySequence: 'Phasellus a est. Phasellus magna. In hac habitasse platea dictumst. Curabitur at lacus ac velit ornare lobortis. Curabitur a felis in nunc fringilla tristique. Morbi mattis ullamcorper velit. Suspendisse eu ligula.',
                keyCount: 180,
                mouseClicks: 55,
                startedAt: `${startDate}T15:45:00`,
                endedAt: `${startDate}T15:55:00`,
            },

        ];

        const term = String(search ?? '').trim().toLowerCase();
        const rows = term
            ? baseRows.filter((row) =>
                [
                    row.displayName,
                    row.keySequence,
                    row.sourceType,
                ].some((value) => String(value ?? '').toLowerCase().includes(term))
            )
            : baseRows;

        const start = Math.max(0, page) * Math.max(1, size);
        const content = rows.slice(start, start + size);

        return {
            employeeId,
            startDate,
            endDate,
            content,
            page: {
                page,
                size,
                totalElements: rows.length,
                totalPages: Math.max(1, Math.ceil(rows.length / Math.max(1, size))),
            },
        };
    },
};
